import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '@services/authentication.service';
import { CxoneService } from '@services/cxone.service';
import { AppConfiguration } from '@config/app-configuration';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';


@Component({
  templateUrl: 'smione-shell.component.html',
  styleUrls: [ 'smione-shell.component.scss' ]
})
export class SmiOneShellComponent implements OnInit, OnDestroy {
   private navFocusSub?: Subscription;
  constructor(
    private authenticationService: AuthenticationService,
    private cxoneService: CxoneService,
    private appConfig: AppConfiguration,
    private router: Router,
    private ngZone: NgZone
  ) {}

  /**
   * WCAG 2.4.1: focus primary page content. Prefer #page-primary (right column on card/manage/settings/support)
   * so tab order does not start in the left sub-navigation.
   */
  skipToMain(event: Event): void {
    event.preventDefault();
    const primary = document.getElementById('page-primary');
    const main = document.getElementById('main-content');
    const container = primary ?? main;
    if (!container) return;


    const focusable = primary?.querySelector<HTMLElement>(
      'input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
    );
    const target = focusable ?? container;


    // Some browsers can ignore focus moves during click; retry on next tick.
    setTimeout(() => {
      target.focus({ preventScroll: false });
      target.scrollIntoView({ behavior: 'auto', block: 'start' });
    }, 0);
  }



  ngOnInit(): void {



    // After in-app navigation, move focus to skip link so the next Tab matches WCAG expectation
    // (header routerLinks keep focus on the link; child views can steal focus on first paint).
    // Wait for zone stability then next macrotask so the first routed view cannot override focus.
    this.navFocusSub = this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        switchMap(() => this.ngZone.onStable.pipe(take(1)))
      )
      .subscribe(() => {
        setTimeout(() => {
          document.querySelector<HTMLElement>('.skip-to-main')?.focus({ preventScroll: true });
        }, 0);
      });


    // Initialize CXone chat only if:
    // 1) user is authenticated AND
    // 2) AllowChat flag is true on at least one card from post-login response
    const hasToken = !!this.authenticationService.getToken();
    let allowChat = false;
   

    const dataStr = localStorage.getItem('data');
    if (dataStr) {
      try {
        const data = JSON.parse(dataStr);
        const cards = data?.Cards || [];
        if (Array.isArray(cards)) {
          allowChat = cards.some((c: any) => c.AllowChat === true);
        }
      } catch (e) {
        console.error('Error parsing post-login data for AllowChat flag', e);
      }
    }


    if (hasToken && allowChat && this.appConfig.display_global_chat) {
      // Use setTimeout to ensure initialization happens after view is ready
      setTimeout(() => {
        this.cxoneService.initialize();
      }, 500);
    }
  }

    ngOnDestroy(): void {
    this.navFocusSub?.unsubscribe();
  }

}



